export default __webpack_public_path__ + "static/media/grundriss-symbol.2b605cc6.svg";